import { callApi } from 'services/api/api'
import { toastStore } from 'stores/toast'
import { TOAST_TYPE } from 'utils/constants'
import { baseURL, isLocalEnv } from 'services/api/apiConfig'
import { sortByEffectiveDateDescending } from 'utils/dataDrawerUtils'
import { specialtiesMock, dataSourcesMocked } from 'mock/AtAGlance/dataSourceMock'
import { appSelected } from 'stores/navigation'

let selectedApplication = 'physician'
appSelected.subscribe(value => {
  if (value.toLocaleLowerCase() === 'app') {
    selectedApplication = 'app'
  } else {
    selectedApplication = 'physician'
  }
})

export const getPercentilesFilter = async () => {
  try {
    const response = await callApi(`${baseURL}/percentiles`, 'GET')
    return response
  } catch (error) {
    console.log(error)
  }
}

export const getAllSpecialties = async () => {
  try {
    const response = await callApi(`${baseURL}/at-a-glance/specialties?type=${selectedApplication}`, 'GET')
    let sortedResponse = sortByEffectiveDateDescending(response)
    return sortedResponse
  } catch (error) {
    if (isLocalEnv) {
      toastStore.createToast(TOAST_TYPE.ERROR, 'Mocked data', 'We are mocking data for getSpecialties')
      let sortedResponse = sortByEffectiveDateDescending(specialtiesMock)
      return sortedResponse
    } else {
      toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting my specialties')
      console.error(error)
      throw error
    }
  }
}

/**
 * Saves the at a glance form.
 */
export const saveAtGlanceCalculatePercentiles = async data => {
  const mockResultsCalculated = false
  return new Promise((resolve, reject) => {
    // for testing purposes you can turn on this flag
    if (mockResultsCalculated) {
      toastStore.createToast(TOAST_TYPE.ERROR, 'Mocked data', 'This At-A-Glance results are being mocked')
      resolve(dataSourcesMocked)
      return
    }
    callApi(`${baseURL}/at-a-glance/calculate-percentiles/${selectedApplication}`, 'POST', data)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error calculate percentiles in at a glance')
        reject(error)
      })
  })
}

export const getAtGlanceDropdownData = async () => {
  try {
    const response = await callApi(`${baseURL}/at-a-glance/enhanced/${selectedApplication}/dropdowns`, 'GET')
    return response
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting my dropdown data')
    console.error(error)
    throw error
  }
}

export const calculateAtGlanceEnhancedData = async data => {
  try {
    const response = await callApi(`${baseURL}/at-a-glance/enhanced/${selectedApplication}/data`, 'POST', data)
    return response
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting At Glance Enhanced data')
    console.error(error)
    throw error
  }
}

export const saveEnhancedAtAGlanceSnapshot = async data => {
  try {
    const response = await callApi(`${baseURL}/at-a-glance/enhanced/${selectedApplication}/snapshot`, 'POST', data)
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const getEnhancedAtAGlanceSnapshot = async enhancedAAGId => {
  try {
    const response = await callApi(`${baseURL}/at-a-glance/enhanced/${selectedApplication}/snapshot?enhancedAAGId=${enhancedAAGId}`, 'GET')
    return response
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error loading At-A-Glance Enhanced report', 6000)
    console.error(error)
    throw error
  }
}

export const getEnhancedAtAGlanceExpertReview = async data => {
  try {
    const response = await callApi(`${baseURL}/at-a-glance/enhanced/${selectedApplication}/expert-review`, 'POST', data)
    return response
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error requesting At-A-Glance Enhanced expert review', 6000)
    console.error(error)
    throw error
  }
}

export const getEnhancedAtAGlanceSnapshots = async () => {
  try {
    const response = await callApi(`${baseURL}/at-a-glance/enhanced/${selectedApplication}/snapshots`, 'GET')
    return response
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error loading At-A-Glance Enhanced saved reports', 6000)
    console.error(error)
    throw error
  }
}

export const deleteEnhancedAtAGlanceReport = async enhancedAAGId => {
  try {
    return await callApi(
      `${baseURL}/at-a-glance/enhanced/${selectedApplication}/snapshot?enhancedAAGId=${encodeURIComponent(enhancedAAGId)}`,
      'DELETE'
    )
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error deleting At-A-Glance Enhanced report', 6000)
    console.error(error)
    throw error
  }
}
